import { useTranslation } from "react-i18next";
import { SchedulePeriod } from "./SchedulePeriod";
import { CommonOptionsSection } from "./CommonOptionsSection";
import { WeeklySchedule } from "./WeeklySchedule";
import { ScheduleJsonControls } from "./ScheduleJsonControls";
import { HistoryControls } from "../history/HistoryControls";
import { PanelLayout } from "../ui/panel-layout";

export function ScheduleInputPanel() {
  const { t } = useTranslation();
  return (
    <section className="h-full min-h-0 w-full min-w-0 rounded border border-neutral-200 bg-white p-4 min-[480px]:p-5" aria-label={t("schedule.input")}>
      <PanelLayout
        className="h-full"
        header={<div className="flex shrink-0 items-center justify-between">
          <h2 className="text-xs font-semibold">{t("schedule.input")}</h2>
          <HistoryControls scheduleOnly />
        </div>}
        footer={<ScheduleJsonControls />}
      >
        <div className="space-y-4 pb-3">
          <SchedulePeriod />
          <WeeklySchedule />
          <CommonOptionsSection />
        </div>
      </PanelLayout>
    </section>
  );
}
